module.exports = __webpack_public_path__ + "img/homework-yx.0029fba3.png";